var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DirectionalHint, TooltipHost as FluentTooltipHost, TooltipDelay, useTheme } from "@fluentui/react";
import React from "react";
import { getBaseTooltipHostStyle, getBaseTooltipStyle } from "./TooltipHost.styles";
// This wrappper around the the Fluent TooltipHost component will allow us to provide consistent styling
// across tooltips in our app at this level.
export const TooltipHost = (_a) => {
    var { children, directionalHint, directionalHintForRTL, target } = _a, rest = __rest(_a, ["children", "directionalHint", "directionalHintForRTL", "target"]);
    const theme = useTheme();
    // directionalHintForRTL: DirectionalHint.rightCenter,
    return (React.createElement(FluentTooltipHost, Object.assign({}, rest, { delay: TooltipDelay.long, styles: getBaseTooltipHostStyle(), tooltipProps: {
            // directionalHint is supposed to be mirrored in RTL but this doesn't happen for leftCenter, which is why we must specify directionalHintForRTL
            calloutProps: {
                directionalHint: directionalHint || DirectionalHint.topLeftEdge,
                directionalHintForRTL: directionalHintForRTL || DirectionalHint.rightCenter,
                gapSpace: 6,
                isBeakVisible: false,
                target: target,
            },
            styles: getBaseTooltipStyle(theme),
        } }), children));
};
